import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: '2.5rem'
  },
  margin: {
    height: theme.spacing(5)
  }
}));

const Rating = ({ low, high, value, onChange }) => {
  const classes = useStyles();

  const marks = [
    {
      value: -1,
      label: 'N/A'
    },
    {
      value: 0,
      label: low
    },
    {
      value: 1
    },
    {
      value: 2
    },
    {
      value: 3
    },
    {
      value: 4
    },
    {
      value: 5
    },
    {
      value: 6
    },
    {
      value: 7
    },
    {
      value: 8
    },
    {
      value: 9
    },
    {
      value: 10,
      label: high
    }
  ];

  const valuetext = (value) => {
    if (value === -1) {
      return 'n/a';
    }
    return `${value}`;
  };

  return (
    <div className={classes.root}>
      <Slider
        aria-labelledby="discrete-slider-custom"
        getAriaValueText={valuetext}
        marks={marks}
        max={10}
        min={-1}
        onChange={onChange}
        scale={(x) => {
          if (x === -1) return 'n/a';
          return x;
        }}
        step={1}
        value={value}
        valueLabelDisplay="on"
      />
    </div>
  );
};

export default Rating;
